export const DAY_MIN_VALUE = 1;
export const DAY_MAX_VALUE = 31;
export const MONTH_MIN_VALUE = 1;
export const MONTH_MAX_VALUE = 12;
export const YEAR_MIN_VALUE = 999;
export const YEAR_MAX_VALUE = 9999;
